// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"9849b282","134":"a24f0aec"}[chunkId] + ".chunk.js";
};